export default __webpack_public_path__ + "static/media/one.7f29ce83.jpg";